import {
  createSupplier,
  deleteStone,
  deleteSupplier,
  importStones,
  listStones,
  listSuppliers,
  updateSupplier,
  type CreateSupplierRequest,
  type ListStones200,
  type ListStonesParams,
  type ListSuppliers200,
  type StoneImportRequest,
  type StoneImportResult,
  type Supplier,
  type UpdateSupplierRequest,
} from '@nucleus-commerce/api-client/platform';

/** The shared stone pool every organization's configurator draws from. */
export const diamondsApi = {
  suppliers: (): Promise<ListSuppliers200> => listSuppliers(),
  createSupplier: (input: CreateSupplierRequest): Promise<Supplier> => createSupplier(input),
  updateSupplier: (id: string, input: UpdateSupplierRequest): Promise<Supplier> =>
    updateSupplier({ id }, input),
  deleteSupplier: (id: string): Promise<void> => deleteSupplier({ id }),
  stones: (params: ListStonesParams): Promise<ListStones200> => listStones(params),
  deleteStone: (id: string): Promise<void> => deleteStone({ id }),
  /** CSV text in a JSON body; upserts by supplier and stone number. */
  importStones: (input: StoneImportRequest): Promise<StoneImportResult> => importStones(input),
};
